import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { OpacityStyleEnum, fontColors, selectionElements } from '@sphereon/ui-components.core';
import { SSICheckboxContainerStyled as Container, SSICheckboxLabelContainerStyled as LabelCaption, SSICheckboxSelectedContainerStyled as SelectedContainer, SSICheckboxUnselectedContainerStyled as UnselectedContainer, } from '../../../styles/components';
const SSICheckbox = (props) => {
    const { backgroundColor, borderColor = selectionElements.primaryBorderDark, disabled = false, initialValue = false, label, selectedColor = selectionElements.primaryDark, labelColor = fontColors.light, checkmarkColor = fontColors.dark } = props;
    const [isChecked, setChecked] = React.useState(initialValue);
    const value = props.isChecked !== undefined ? props.isChecked : isChecked;
    const onValueChange = async () => {
        const { onValueChange } = props;
        if (disabled) {
            return;
        }
        if (onValueChange) {
            await onValueChange(!isChecked);
        }
        setChecked(!isChecked);
    };
    return (_jsxs(Container, { onClick: onValueChange, style: { ...(disabled && { opacity: OpacityStyleEnum.DISABLED }) }, children: [value ? (_jsx(SelectedContainer, { style: { backgroundColor: selectedColor, border: `1px solid ${borderColor}` } })) : (_jsx(UnselectedContainer, { style: { backgroundColor, border: `1px solid ${borderColor}` } })), label &&
                (typeof label === 'string'
                    ? _jsx(LabelCaption, { style: { color: labelColor }, children: label })
                    : label)] }));
};
export default SSICheckbox;
